var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.outputFrames),function(outputFrame){return _c('div',{key:outputFrame._key},[(outputFrame.fragments.length > 0)?_c('output-frame',{attrs:{"output-frame":outputFrame}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }